<template>
    <loading-block-ui v-if="mostrarSpinnerGlobal"></loading-block-ui>
    <Toast :baseZIndex="1000" />
    <ConfirmDialog></ConfirmDialog>
    <router-view></router-view>
</template>

<script>
import { isSolicitacoesRoute } from '@/app/solicitacoes/utils/isSolicitacoesRoute';

const INTERVALO_VERIFICACAO_VERSAO_MS = 5 * 60 * 1000;

export default {
    computed: {
        mostrarSpinnerGlobal() {
            return this.$store.getters.isLoading && !isSolicitacoesRoute(this.$route);
        },
    },

    methods: {
        async obterConfig() {
            try {
                await this.$store.dispatch('carregarConfigApp');
            } catch (error) {
                console.error('Falha ao carregar configurações do app.', error);
            }
        },

        verificarVersao() {
            this.$store.dispatch('verificarVersao');
        },

        aoVoltarParaAba() {
            if (!document.hidden) {
                this.verificarVersao();
            }
        },
    },

    async beforeCreate() {
        await this.$store.dispatch('verificarVersao');
    },

    async mounted() {
        // Aba aberta há dias nunca detectaria versão nova só com a checagem do boot
        this.intervaloVersao = setInterval(this.verificarVersao, INTERVALO_VERIFICACAO_VERSAO_MS);
        document.addEventListener('visibilitychange', this.aoVoltarParaAba);
        await this.obterConfig();
    },

    beforeUnmount() {
        clearInterval(this.intervaloVersao);
        document.removeEventListener('visibilitychange', this.aoVoltarParaAba);
    },
};
</script>
